import { inject, injectable } from "@launchtray/tsyringe-async";
import { ISettingsController } from "by/gamefactory/cityversetycoon/settings/ISettingsController";
import { ISettingsModel } from "by/gamefactory/cityversetycoon/settings/ISettingsModel";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { Viewable } from "../../../../../scene/viewable/Viewable";
import { IGuestModel } from "../../../common/models/IGuestModel";
import { IPlayerModel } from "../../../common/models/IPlayerModel";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { SoundsResourcePackageWrapper } from "../../../common/resources/SoundsResourcePackageWrapper";
import { IGameViewModel } from "../../../game/models/IGameViewModel";
import { IUserLevelUpModel } from "../../userlevelup/model/IUserLevelUpModel";
import { ProfileController } from "./controllers/ProfileController";
import { UserProfileResourcePackage } from "../resources/UserProfileResourcePackage";
import { UserProfilePopupView } from "./views/UserProfilePopupView";
import { IGameController } from "../../../game/controllers/IGameController";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { Web3Model } from "../../../../../web3/models/Web3Model";
import { UserProfileResult } from "./UserProfileResult";

export type UserProfileSceneOptions = {
    userLevelUpModel: IUserLevelUpModel;
}

@injectable()
export class UserProfilePopupScene extends Viewable<UserProfileResult> {
    public constructor(
        userProfileResources: UserProfileResourcePackage,
        commonResources: CommonResourcesPackage,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("IProfileController") profileController: ProfileController,
        @inject("IGuestModel") guestModel: IGuestModel,
        @inject("IPlayerModel") playerModel: IPlayerModel,
        web3Model: Web3Model,
        @inject("ISettingsModel") settingsModel: ISettingsModel,
        @inject("ISettingsController") settingsController: ISettingsController,
        soundResources: SoundsResourcePackageWrapper,
        @inject("IGameViewModel") gameViewModel: IGameViewModel,
        @inject("IGameController") gameController: IGameController,
        @inject("ILogger") logger: ILogger,
        @inject("UserProfileSceneOptions") options: UserProfileSceneOptions,
    ) {
        super();
        const pcs = new PromiseCompletionSource<UserProfileResult>();
        this.view = new UserProfilePopupView(
            pcs,
            userProfileResources,
            commonResources,
            canvasScaler,
            profileController,
            guestModel,
            playerModel,
            web3Model,
            options.userLevelUpModel,
            soundResources,
            settingsModel,
            settingsController,
            gameViewModel,
            gameController,
            logger
        );
        pcs.result.then((result: UserProfileResult) => {
            this.operationControls.complete(result);
            userProfileResources.destroy();
        }, (reason: any) => {
            this.operationControls.error(reason);
        });
    }
}
